const contexts = {
    'en-GB': require.context('./en-GB', false, /\.json$/),
};

export default Object.keys(contexts)
    .reduce((translationObject, language) => {
        const context = contexts[language];
        translationObject[language] = context.keys().reduce((translations, translationFile) => {
            // get the filename, which should be the same as the top-level translation key
            const key = translationFile.split('/').pop().split('.')[0];
            translations[key] = context(translationFile);

            return translations;
        }, {});

        return translationObject;
    }, {});
